/**
 * Credit Control - Query Keys
 */

export const queryKey = {
  getCreditControlOrders: 'CREDIT_CONTROL_GET_ORDERS',
  getCreditControlOrdersCount: 'CREDIT_CONTROL_GET_ORDERS_COUNT',
  approveCreditLimit: 'CREDIT_CONTROL_APPROVE_LIMIT',
};

/**
 * Credit Control Status Code
 * statuscode eq 736000002 = Orders pending credit approval
 */
export const CREDIT_CONTROL_STATUS_CODE = 736000002;
